<template>
  <div>
    <div class="toolbtn flex" v-if="activeName == 'first'">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <div class="toolbtn flex" v-if="activeName == 'second'">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refreshs()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <div class="toolbtn flex" v-if="activeName == 'third'">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refreshss()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton class="width100" :loading="loading" animated :throttle="500">
      <template slot="template">
        <div class="width100 margin-auto pad-top10 backwhite border-rd3">
          <el-tabs v-model="activeName" class="width98 margin-auto">
            <el-tab-pane label="商标申请" name="first">
              <!-- 关键词检索  -->
              <div
                class="width100 f14 backwhite border-rd3 flex-betweenwrap"
                style="min-height: 72px"
                v-if="serchkey"
              >
                <el-form
                  ref="ruleForm"
                  size="small"
                  label-width="60px"
                  class="demo-ruleForm flexleft"
                >
                  <el-form-item label="关键词">
                    <el-input
                      placeholder="请输入关键词"
                      v-model="input"
                    ></el-input>
                  </el-form-item>
                  <div class="margin-left20 margin-top10 margin-bot10">
                    <el-button type="primary" @click="submitForm()"
                      >检 索</el-button
                    >
                    <el-button @click="resetForm()">重 置</el-button>
                  </div>
                </el-form>
                <span
                  class="
                    attention
                    margin-top10 margin-bot10 margin-left20 margin-right20
                  "
                  @click="tohandle()"
                  >办理商标</span
                >
              </div>
            </el-tab-pane>
            <el-tab-pane label="专利申请" name="second">
              <!-- 关键词检索  -->
              <div
                class="width100 f14 backwhite border-rd3 flex-betweenwrap"
                style="min-height: 72px"
                v-if="serchkey"
              >
                <el-form
                  ref="ruleForm"
                  size="small"
                  label-width="60px"
                  class="demo-ruleForm flexleft"
                >
                  <el-form-item label="关键词">
                    <el-input
                      placeholder="请输入关键词"
                      v-model="inputs"
                    ></el-input>
                  </el-form-item>
                  <div class="margin-left20 margin-top10 margin-bot10">
                    <el-button type="primary" @click="submitForms()"
                      >检 索</el-button
                    >
                    <el-button @click="resetForms()">重 置</el-button>
                  </div>
                </el-form>
                <span
                  class="
                    attention
                    margin-top10 margin-bot10 margin-left20 margin-right20
                  "
                  @click="tohandles()"
                  >办理专利</span
                >
              </div>
            </el-tab-pane>
            <el-tab-pane label="版权软著" name="third">
              <!-- 关键词检索  -->
              <div
                class="width100 f14 backwhite border-rd3 flex-betweenwrap"
                style="min-height: 72px"
                v-if="serchkey"
              >
                <el-form
                  ref="ruleForm"
                  size="small"
                  label-width="60px"
                  class="demo-ruleForm flexleft"
                >
                  <el-form-item label="关键词">
                    <el-input
                      placeholder="请输入关键词"
                      v-model="inputss"
                    ></el-input>
                  </el-form-item>
                  <div class="margin-left20 margin-top10 margin-bot10">
                    <el-button type="primary" @click="submitFormss()"
                      >检 索</el-button
                    >
                    <el-button @click="resetFormss()">重 置</el-button>
                  </div>
                </el-form>
                <span
                  class="
                    attention
                    margin-top10 margin-bot10 margin-left20 margin-right20
                  "
                  @click="tohandless()"
                  >办理软著</span
                >
              </div>
            </el-tab-pane>
          </el-tabs>

          <el-dialog
            title=""
            :visible.sync="dialogVisiblenull"
            :close-on-click-modal="false"
            :show-close="true"
            :center="true"
            :modal="true"
            :modal-append-to-body="true"
            :append-to-body="true"
            width="25%"
            class="errorbox"
          >
            <span class="errormessage">{{ errormessage }}</span>
            <span slot="footer" class="dialog-footer">
              <button @click="dialogVisiblenull = false" class="errorbutton">
                确 定
              </button>
            </span>
          </el-dialog>
          <el-dialog
            class="trusteeshipdialog"
            :visible.sync="dialogtrusttrandmark"
            :close-on-click-modal="false"
            :show-close="true"
            :append-to-body="true"
            :before-close="closetrandmark"
            width="40%"
          >
            <trandmarkapplication></trandmarkapplication>
          </el-dialog>
          <el-dialog
            class="trusteeshipdialog"
            :visible.sync="dialogtrustpatent"
            :close-on-click-modal="false"
            :show-close="true"
            :append-to-body="true"
            width="30%"
          >
            <Patentapplication></Patentapplication>
          </el-dialog>
          <el-dialog
            class="trusteeshipdialog"
            :visible.sync="dialogtrustsoftcopy"
            :close-on-click-modal="false"
            :show-close="true"
            :append-to-body="true"
            width="30%"
          >
            <softapplication></softapplication>
          </el-dialog>
          <el-dialog
            :title="title"
            :visible.sync="open"
            append-to-body
            width="40%"
          >
            <el-transfer
              :titles="['全选', '全选']"
              v-model="value"
              :data="columns"
              @change="dataChange"
            ></el-transfer>
          </el-dialog>
        </div>
      </template>
    </el-skeleton>
    <el-skeleton
      v-if="activeName == 'first'"
      class="width100 backwhite border-rd3"
      :loading="loading"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width98
            backwhite
            pad-top20 pad-bot20
            margin-auto margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <el-table
            :data="page"
            stripe
            class="width100 eltable margin-auto f14"
          >
            <el-table-column
              label="商标名称"
              width="380"
              v-if="columns[0].visible"
            >
              <template slot-scope="scope">
                <span
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                  "
                  class="f14"
                >
                  {{ scope.row.trademark }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="apply_date"
              label="申请日期"
              width="180"
              v-if="columns[1].visible"
            >
            </el-table-column>
            <el-table-column
              prop="contact"
              label="联系人"
              v-if="columns[2].visible"
            >
            </el-table-column>
            <el-table-column
              prop="class_id"
              label="申请分类"
              v-if="columns[3].visible"
            >
            </el-table-column>

            <el-table-column label="图片" v-if="columns[4].visible">
              <template slot-scope="scope">
                <img class="trandmarkimg" :src="scope.row.image" alt="" />
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              v-if="columns[5].visible"
              width="180"
            >
              <template slot-scope="scope">
                <span
                  class="bluecolor cursorpointer"
                  @click="designDetail(scope.row)"
                  >取消申请</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="parseInt(per_page)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>
    <el-skeleton
      v-if="activeName == 'second'"
      class="width100 backwhite border-rd3"
      :loading="loading"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width98
            backwhite
            pad-top20 pad-bot20
            margin-auto margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="totals != 0"
        >
          <el-table
            :data="pages"
            stripe
            class="width100 eltable margin-auto f14"
          >
            <el-table-column label="专利名称">
              <template slot-scope="scope">
                <span class="f14">
                  <span>{{ scope.row.patent }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="patent_type" label="专利类型">
            </el-table-column>
            <el-table-column prop="contact" label="联系人"> </el-table-column>
            <el-table-column prop="apply_date" label="计划申请时间">
            </el-table-column>
            <el-table-column label="包含交底材料">
              <template slot-scope="scope">
                <span class="f14">
                  <span>{{ scope.row.file }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <span
                  class="f14 cursorpointer bluecolor"
                  @click="designDetails(scope.row)"
                >
                  <span>取消申请</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="totals != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChanges"
              @current-change="currentchanges"
              :current-page="currentPages"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_pages"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totals"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="totals == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>
    <el-skeleton
      v-if="activeName == 'third'"
      class="width100 backwhite border-rd3"
      :loading="loading"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width98
            backwhite
            pad-top20 pad-bot20
            margin-auto margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="totalss != 0"
        >
          <el-table
            :data="pagess"
            stripe
            class="width100 eltable margin-auto f14"
          >
            <el-table-column label="软著名称">
              <template slot-scope="scope">
                <span class="f14">
                  <span>{{ scope.row.software }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="copyright_type" label="软著类型">
            </el-table-column>
            <el-table-column prop="contact" label="联系人"> </el-table-column>
            <el-table-column prop="apply_date" label="计划申请时间">
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <span
                  class="f14 cursorpointer bluecolor margin-left10"
                  @click="designDetailss(scope.row)"
                >
                  <span>取消申请</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="totalss != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChangess"
              @current-change="currentchangess"
              :current-page="currentPagess"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_pagess"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalss"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="totalss == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>
  </div>
</template>
<script>
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import {
  entpatentapplyindex,
  enttrademarkapplyindex,
  entcopyrightapplyindex,
  entpatentapplydelete,
  enttrademarkapplydelete,
  entcopyrightapplydelete,
} from "@/api/newhead/newhead.api";
import BUS from "@/BUS/BUS";
import trandmarkapplication from "./trandmark-application.vue";
import Patentapplication from "./Patent-application.vue";
import softapplication from "./soft-application.vue";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      dialogtrusttrandmark: false,
      dialogtrustpatent: false,
      dialogtrustsoftcopy: false,
      thisNum: 1,
      thisNums: 1,
      thisNumss: 1,
      page: [],
      pages: [],
      pagess: [],
      total: 0,
      totals: 0,
      totalss: 0,
      per_page: 0,
      per_pages: 0,
      per_pagess: 0,
      currentPage: 1,
      currentPages: 1,
      currentPagess: 1,
      pagination: false,
      paginations: false,
      paginationss: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      input: "",
      inputs: "",
      inputss: "",
      activeName: "",
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      columns: [
        { key: 0, label: `商标名称`, visible: true },
        { key: 1, label: `申请日期`, visible: true },
        { key: 2, label: `联系人`, visible: true },
        { key: 3, label: `申请分类`, visible: true },
        { key: 4, label: `图片`, visible: true },
        { key: 5, label: `操作`, visible: true },
      ],
    };
  },
  components: {
    callback,
    switchcore,
    trandmarkapplication,
    Patentapplication,
    softapplication,
  },

  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    // 第一个分页商标
    currentchange(val) {
      enttrademarkapplyindex({ page: val, _keywords: this.input }).then(
        (res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            this.pagination = true;
            this.page.forEach((i) => {
              i.image = window.g.Apisrc + i.image;
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    handleSizeChange(val) {
      enttrademarkapplyindex({
        page: 1,
        limit: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pagination = true;
          this.page.forEach((i) => {
            i.image = window.g.Apisrc + i.image;
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页专利
    currentchanges(val) {
      this.thisNums = val;
      entpatentapplyindex({ page: val, _keywords: this.inputs }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.patent_type == 1) {
              i.patent_type = "发明专利";
            } else if (i.patent_type == 2) {
              i.patent_type = "实用新型";
            } else {
              i.patent_type = "外观专利";
            }
            if (i.file == "") {
              i.file = "否";
            } else {
              i.file = "是";
            }
          });
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChanges(val) {
      entpatentapplyindex({
        page: 1,
        limit: val,
        _keywords: this.inputs,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.patent_type == 1) {
              i.patent_type = "发明专利";
            } else if (i.patent_type == 2) {
              i.patent_type = "实用新型";
            } else {
              i.patent_type = "外观专利";
            }
            if (i.file == "") {
              i.file = "否";
            } else {
              i.file = "是";
            }
          });
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页软著
    currentchangess(val) {
      this.thisNumss = val;
      entcopyrightapplyindex({ page: val, _keywords: this.inputss }).then(
        (res) => {
          if (res.data.code == 200) {
            this.pagess = res.data.data.data;
            this.pagess.forEach((i) => {
              if (i.copyright_type == 1) {
                i.copyright_type = "软件著作权";
              } else if (i.copyright_type == 2) {
                i.copyright_type = "作品版权";
              }
            });
            this.paginationss = true;
            this.totalss = res.data.data.total;
            this.per_pagess = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    handleSizeChangess(val) {
      entcopyrightapplyindex({
        page: 1,
        limit: val,
        _keywords: this.inputss,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagess = res.data.data.data;
          this.pagess.forEach((i) => {
            if (i.copyright_type == 1) {
              i.copyright_type = "软件著作权";
            } else if (i.copyright_type == 2) {
              i.copyright_type = "作品版权";
            }
          });
          this.paginationss = true;
          this.totalss = res.data.data.total;
          this.per_pagess = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置专利
    resetForms() {
      this.inputs = null;
      entpatentapplyindex({
        page: this.thisNums,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.patent_type == 1) {
              i.patent_type = "发明专利";
            } else if (i.patent_type == 2) {
              i.patent_type = "实用新型";
            } else {
              i.patent_type = "外观专利";
            }
            if (i.file == "") {
              i.file = "否";
            } else {
              i.file = "是";
            }
          });
          this.totals = res.data.data.total;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置商标
    resetForm() {
      this.input = null;
      // 获取申请商标
      enttrademarkapplyindex({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.page.forEach((i) => {
            i.image = window.g.Apisrc + i.image;
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置软著
    resetFormss() {
      this.inputss = null;
      entcopyrightapplyindex({
        page: this.thisNumss,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagess = res.data.data.data;
          this.pagess.forEach((i) => {
            if (i.copyright_type == 1) {
              i.copyright_type = "软件著作权";
            } else if (i.copyright_type == 2) {
              i.copyright_type = "作品版权";
            }
          });
          this.totalss = res.data.data.total;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 取消专利申请
    designDetails(row) {
      this.$confirm("此操作将取消申请专利, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entpatentapplydelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.activeName = "second";
              this.refreshs();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 取消商标申请
    designDetail(row) {
      this.$confirm("此操作将取消申请商标, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          enttrademarkapplydelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.activeName = "first";
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 取消软著申请

    designDetailss(row) {
      this.$confirm("此操作将取消申请软著, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entcopyrightapplydelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.activeName = "third";
              this.refreshss();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 专利模糊查询 // 关键词检索
    submitForms() {
      entpatentapplyindex({ _keywords: this.inputs }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.patent_type == 1) {
              i.patent_type = "发明专利";
            } else if (i.patent_type == 2) {
              i.patent_type = "实用新型";
            } else {
              i.patent_type = "外观专利";
            }

            if (i.file == "") {
              i.file = "否";
            } else {
              i.file = "是";
            }
          });
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 商标模糊查询  // 关键词检索
    submitForm() {
      enttrademarkapplyindex({ _keywords: this.input }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pagination = true;
          this.page.forEach((i) => {
            i.image = window.g.Apisrc + i.image;
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 软著模糊查询  // 关键词检索
    submitFormss() {
      entcopyrightapplyindex({ _keywords: this.inputss }).then((res) => {
        if (res.data.code == 200) {
          this.pagess = res.data.data.data;
          this.pagess.forEach((i) => {
            if (i.copyright_type == 1) {
              i.copyright_type = "软件著作权";
            } else if (i.copyright_type == 2) {
              i.copyright_type = "作品版权";
            }
          });
          this.paginationss = true;
          this.totalss = res.data.data.total;
          this.per_pagess = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    tohandle() {
      this.dialogtrusttrandmark = true;
    },
    closetrandmark(done) {
      this.dialogtrusttrandmark = false;
      this.refresh();
    },
    tohandles() {
      this.dialogtrustpatent = true;
    },
    tohandless() {
      this.dialogtrustsoftcopy = true;
    },
    refresh() {
      this.$loading.show(); // 显示loading
      // 获取申请商标
      enttrademarkapplyindex({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pagination = true;
          this.page.forEach((i) => {
            i.image = window.g.Apisrc + i.image;
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refreshs() {
      this.$loading.show(); // 显示loading
      // 获取申请专利
      entpatentapplyindex({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.pages.forEach((i) => {
            if (i.patent_type == 1) {
              i.patent_type = "发明专利";
            } else if (i.patent_type == 2) {
              i.patent_type = "实用新型";
            } else {
              i.patent_type = "外观专利";
            }

            if (i.file == "") {
              i.file = "否";
            } else {
              i.file = "是";
            }
          });
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refreshss() {
      this.$loading.show(); // 显示loading
      // 获取申请软著
      entcopyrightapplyindex({ page: this.thisNumss }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagess = res.data.data.data;
          this.pagess.forEach((i) => {
            if (i.copyright_type == 1) {
              i.copyright_type = "软件著作权";
            } else if (i.copyright_type == 2) {
              i.copyright_type = "作品版权";
            }
          });
          this.paginationss = true;
          this.totalss = res.data.data.total;
          this.per_pagess = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },

  created() {
    this.activeName = "first";

    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    // 获取申请专利
    entpatentapplyindex({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.pages = res.data.data.data;
        this.pages.forEach((i) => {
          if (i.patent_type == 1) {
            i.patent_type = "发明专利";
          } else if (i.patent_type == 2) {
            i.patent_type = "实用新型";
          } else {
            i.patent_type = "外观专利";
          }

          if (i.file == "") {
            i.file = "否";
          } else {
            i.file = "是";
          }
        });
        this.paginations = true;
        this.totals = res.data.data.total;
        this.per_pages = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 获取申请商标
    enttrademarkapplyindex({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.pagination = true;
        this.page.forEach((i) => {
          i.image = window.g.Apisrc + i.image;
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 获取申请软著
    entcopyrightapplyindex({ page: this.thisNumss }).then((res) => {
      if (res.data.code == 200) {
        this.pagess = res.data.data.data;
        this.pagess.forEach((i) => {
          if (i.copyright_type == 1) {
            i.copyright_type = "软件著作权";
          } else if (i.copyright_type == 2) {
            i.copyright_type = "作品版权";
          }
        });
        this.paginationss = true;
        this.totalss = res.data.data.total;
        this.per_pagess = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("Applyfor", (data) => {
      if (data == "yes") {
        this.dialogtrusttrandmark = false;
        this.refresh();
      } else if (data == "yess") {
        this.dialogtrustpatent = false;
        this.refreshs();
      } else if (data == "yesss") {
        this.dialogtrustsoftcopy = false;
        this.refreshss();
      } else {
        this.dialogtrusttrandmark = false;
        this.dialogtrustpatent = false;
        this.dialogtrustsoftcopy = false;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.hovercont:hover {
  background: #f7f9fc;
}
.borcenter {
  border-left: 2px solid #efefef;
}
.trandmarkimg {
  width: 45px;
  height: 45px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}

.trusteeshipdialog >>> .el-dialog__header {
  padding: 0;
}
.trusteeshipdialog >>> .el-dialog__body {
  padding: 0;
}
.trusteeshipdialog >>> .el-dialog__footer {
  padding: 10px 0 10px 10px;
  text-align: left;
}
</style>